export const clearLocalStorageExcept = (keysToPreserve = []) => {
  const preservedValues = keysToPreserve.reduce((values, key) => {
    try {
      const value = window.localStorage.getItem(key)

      return value ? { ...values, [key]: value } : values
    } catch (e) {
      return values
    }
  }, {})

  try {
    window.localStorage.clear()
  } catch (e) {
    return
  }

  Object.keys(preservedValues).forEach((key) => {
    try {
      window.localStorage.setItem(key, preservedValues[key])
    } catch (e) {
      // localStorage may become unavailable between clear and restore.
    }
  })
}
